import React from 'react';
import Navbar from '../components/Navbar';
import './Archives.css';
import kamuBackground from '../assets/kamubackground.png';
import reconBackground from '../assets/reconbackground.png';
import recondbLogo from '../assets/recondb.png';

const Archives = () => {
  return (
    <div className="archives-container">
      <h1 className="seo-visually-hidden">电子游戏历史档案馆</h1>
      <Navbar />
      <div className="archives-strips">

        <a href="/recondb" className="archive-strip">
          <div
            className="archive-strip-bg"
            style={{ backgroundImage: `url(${reconBackground})` }}
          />
          <div className="archive-strip-overlay" />
          <div className="archive-strip-body">
            <div className="archive-strip-left">
              <img src={recondbLogo} alt="ReconDB" className="archive-strip-logo" />
              <p className="archive-strip-description">
                Recondb旨在成为早期电子游戏ROM社区逆向工程成果的完整列表，现已收录百余爱好者社区的电子游戏解汇编成果，旨于成为电子游戏历史研究，平台研究，和批判性代码研究的重要资源。
              </p>
            </div>
            <div className="archive-strip-cta">
              <span className="archive-strip-btn">点击访问</span>
            </div>
          </div>
        </a>

        <a href="/kamulewu" className="archive-strip">
          <div
            className="archive-strip-bg"
            style={{ backgroundImage: `url(${kamuBackground})` }}
          />
          <div className="archive-strip-overlay" />
          <div className="archive-strip-body">
            <div className="archive-strip-left">
              <h2 className="archive-strip-title">卡姆乐屋档案</h2>
              <p className="archive-strip-description">
                卡姆乐屋档案记录了北京游戏店"卡姆乐屋"中保存的一批手写游戏攻略、翻译与研究笔记。它们大多出自学生玩家之手，见证了在中文资料匮乏的年代，玩家如何靠自发翻译与集体摸索，让更多外文游戏被理解、被玩到，是中国早期玩家社群的鲜活写照。
              </p>
            </div>
            <div className="archive-strip-cta">
              <span className="archive-strip-btn">点击访问</span>
            </div>
          </div>
        </a>

        <a href="/newspaper-archive" className="archive-strip archive-strip-newspaper">
          <div className="archive-strip-bg archive-strip-newspaper-bg" />
          <div className="archive-strip-overlay" />
          <div className="archive-strip-body">
            <div className="archive-strip-left">
              <h2 className="archive-strip-title">报纸档案</h2>
              <p className="archive-strip-description">
                收录报纸中电子游戏的历史报道，以可检索的时间轴呈现电子游戏如何进入社会视野、公共讨论与日常生活。首批馆藏为人民日报历史报道，档案将持续增补。
              </p>
            </div>
            <div className="archive-strip-cta">
              <span className="archive-strip-btn">进入时间轴</span>
            </div>
          </div>
        </a>

        <a href="/oral-history" className="archive-strip archive-strip-oral">
          <div className="archive-strip-bg archive-strip-oral-bg" />
          <div className="archive-strip-overlay" />
          <div className="archive-strip-body">
            <div className="archive-strip-left">
              <h2 className="archive-strip-title">游戏口述史</h2>
              <p className="archive-strip-description">
                游戏口述史以个人视角记录人与游戏相遇、相伴与创造的故事，保存电子游戏背后真实而鲜活的记忆。
              </p>
            </div>
            <div className="archive-strip-cta">
              <span className="archive-strip-btn">阅读口述史</span>
            </div>
          </div>
        </a>

      </div>
    </div>
  );
};

export default Archives;
